export default __webpack_public_path__ + "static/media/2015.741a73f5.png";